import React from 'react'
import {  Container, Row } from 'react-bootstrap';

const projectData = [
    /*{
        id: 1,
        title: "NTPC 300 MW - Jatavira & Moti - Nakhatrana",
        period: "2023",
        work: "33/220 KVA Sub Station",
        client: "Srex Power"
    },*/
    {
        id: 1,
        title: "260 MV SGEL Solar Power Plant - Vill. Bhadra",
        period: "2024",
        work: "PILLING FOUNDATION",
        client: "SOLAR WORLD"
    },
    /*{
        id: 3,
        title: "Road Work AT Lakhpat Taluka",
        period: "2023",
        work: "Road Work",
        client: "SUZLON"
    },*/
    {
        id: 2,
        title: "GIPCL - POOLING SUB STATION 400/33 KV RE PARK - KHAVDA",
        period: "2023-24",
        work: "Civil Foundation",
        client: "EPC - Contractor KEC International LTD."
    },
    /*{
        id: 5,
        title: "Road Work AT Nakhatrana Taluka",
        period: "2020",
        work: "Road Work",
        client: "inox"
    },*/
    {
        id: 3,
        title: "Back Filling Work AT Smart City Dholera",
        period: "2021",
        work: "Back Filling",
        client: "KRUNAL CONSTRUCTION"
    },
    /*{
        id: 7,
        title: "NTPC PROJECT - Dayapar",
        period: "2021",
        work: "Wind Foundation & Excavation Work",
        client: "INOX"
    },*/
     {
        id: 4,
        title: "GSECL 33/440KV Substation RE Park Khavda",
        period: "2024-2025",
        work: "Sub Station Civil Work",
        client: "Amara Raja Infra PVT. LTD."
    },
     {
        id: 5,
        title: "GIPCL 600MW Solar PV Project",
        period: "2024-2025",
        work: "150mw / Main Control Room / ICR / Tracker Pilling",
        client: "Sterling And Wilson Renewable Energy Ltd"
    },
     {
        id: 6,
        title: "GIPCL 600MW Solar PV Project",
        period: "22024-2025",
        work: "Tracker Installation / AC/DC (MMS Module)",
        client: "Sterling And Wilson Renewable Energy Ltd"
    },
     {
        id: 7,
        title: "GSECL 33/400KV 1361MV North Block Pooling Sub Station",
        period: "2024-2025",
        work: "TMR Pilling Work / Sub Station Civil Foundation",
        client: "Kintech Synergy Pvt Ltd"
    },
     {
        id: 8,
        title: "NHPC 200MW Grid Connected Solar PV Project At GSECL RE Park Khavda",
        period: "2025",
        work: "Road Work / Drain",
        client: "Dineshchandra R. Agrawal Infracon Pvt. Ltd."
    },
     {
        id: 9,
        title: "NHPC 200MW Grid Connected Solar PV Project At GSECL RE Park Khavda",
        period: "2025",
        work: "50mw EPC Basis / Invetor Control Room / Tracker Pilling / AC/DC",
        client: "Dineshchandra R. Agrawal Infracon Pvt. Ltd."
    },
     {
        id: 10,
        title: "ADANI Halvad 765 kv D/C line under khavda re park phase-III part A",
        period: "2025",
        work: "765KV Double Circuit Transmission Line Pilling And Foundation",
        client: "TATA PROJECTS LIMITED"
    },
     {
        id: 11,
        title: "JSW 300MW AC Solar Ground Mounted Project RE Park Khavda",
        period: "2025",
        work: "50 mw / Main Control Room / ICR / Pile Foundation / AC/DC",
        client: "O2 Power Private Limited"
    }
];


export default function ProjectsComplete() {
    return (
        <Container className="mission" >
            <div className="text-center">
                <h2 className='center'><span>Projects</span> Completed  </h2><br />
                {/* <p>What makes us the best choice</p> */}
            </div>
            <Row className='d-flex justify-content-center pt-5'>
                {/* {projectData.map((item) => {
                    return <Col md={3} className="mission-row pt-3" key={item.id}>
                        <div className="card-mission-1">
                            <h3 className='text-start'>{item.title}</h3>
                            <p><span className='fw-bold'>Period : </span>{item.period}</p>
                            <p><span className='fw-bold'>Work : </span>{item.work}</p>
                            <p><span className='fw-bold'>Client : </span>{item.client}</p>
                        </div>
                    </Col>}
                )} */}
                <div className="table-responsive">
                    <table className="table table-bordered table-hover table-striped spec-table">
                        <thead className="table-secondary">
                            <tr>
                            <th className="text-center">No.</th>
                                <th className="text-center">Title</th>
                                <th className="text-center">Period</th>
                                <th className="text-center">Work</th>
                                <th className="text-center">Client</th>
                            </tr>
                        </thead>
                        <tbody>
                            {projectData.map((item) => (
                                <tr key={item.id}>
                                    <td>{item.id}.</td>
                                    <td>{item.title}</td>
                                    <td>{item.period}</td>
                                    <td>{item.work}</td>
                                    <td>{item.client}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

            </Row>
        </Container >
    )
}
